export class FindUserUseCaseImpl {
    constructor(userRepository) {
        this.userRepository = userRepository;
    }
    run(username) {
        return this.userRepository.findUserByUsername(username);
    }
}
